import React, { useState } from "react";

import {
  DatePicker,
  Form,
  Input,
  Select,
  Button,
  Col,
  Row,
  Card,
  Checkbox,
} from "antd";
import { v4 as uuidv4 } from "uuid";
import { states } from "../../../../utils/Util";

const { TextArea } = Input;

function Emails({ previousAddresses, setPreviousAddresses }) {

  const addPreviousAddress = () => {
    const newPreviousAddresses = {
      id: uuidv4(),
      addressOne: "",
      addressTwo: "",
      city: "",
      state: "",
      zipCode: "",
      country: "",
      residedFrom: "",
      residedTo: "",
      monthlyRent: "",
      lanlordName: "",
      lanlordPhoneNumber: "",
      landlordEmailAddress: "",
      reasonForLeaving: "",
    };
    setPreviousAddresses([...previousAddresses, newPreviousAddresses]);
  };

  const removePreviousAddress = (id) => {
    const updatedPreviousAddresses = previousAddresses.filter(
      (item) => item.id !== id
    );
    setPreviousAddresses(updatedPreviousAddresses);
  };

  const handleChange = (value, name, id) => {
    const updatedPreviousAddresses = previousAddresses.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setPreviousAddresses(updatedPreviousAddresses);
  };

  return (
    <>
      <ul>
        <li>
          <Card title="Current Address">
            <Form.Item
              name="currentAddress1"
              label="Current Address"
              rules={[
                {
                  required: true,
                  message: "Please enter your Current address!",
                },
              ]}
            >
              <Input placeholder="Address 1" />
            </Form.Item>
            <Form.Item label=" " name="currentAddress2">
              <Input placeholder="Address 2" />
            </Form.Item>
            <Row>
              <Col span={10} style={{ marginLeft: "17%" }}>
                <Form.Item label=" " name="currentCity">
                  <Input placeholder="City" />
                </Form.Item>
              </Col>
              <Col flex={1}></Col>
              <Col flex={5} span={5}>
                <Form.Item label=" " name="currentState">
                  <Select options={states} />
                </Form.Item>
              </Col>
              <Col flex={1}></Col>
              <Col flex={2}>
                <Form.Item label="" name="currentZip">
                  <Input placeholder="Zip" />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              name="currentCountry"
              label="Country"
              rules={[
                {
                  required: true,
                  message: "Please enter your Current Country!",
                },
              ]}
            >
              <Input placeholder="Country" />
            </Form.Item>
            <Form.Item
              name="currentResidedFrom"
              label="Resided From"
              wrapperCol={{ span: 8 }}
            >
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
            <Form.Item
              name="currentResidedTo"
              label="Resided To"
              wrapperCol={{ span: 8 }}
            >
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
            <Form.Item
              label="Monthly Rent"
              name="currentMonthlyRent"
              wrapperCol={{ span: 8 }}
            >
              <Input prefix="$" />
            </Form.Item>
            <Form.Item
              label="Landlord Name"
              name="currentLandLordName"
              wrapperCol={{ span: 8 }}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Landlord Phone Number"
              name="currentLandLordNum"
              wrapperCol={{ span: 8 }}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Landlord Email Address"
              name="currentLandLordEmail"
              wrapperCol={{ span: 8 }}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Reason For Leaving"
              name="currentLandLordReason"
              wrapperCol={{ span: 8 }}
            >
              <TextArea rows={4} />
            </Form.Item>
          </Card>
        </li>
      </ul>
      <ul>
        {previousAddresses.map((item, index) => (
          <li key={item.id}>
            <Card
              title="Previous Address"
              extra={
                index === 0 ? (
                  <></>
                ) : (
                  <a
                    onClick={() => {
                      removePreviousAddress(item.id);
                    }}
                  >
                    Delete
                  </a>
                )
              }
            >
              <Form.Item
                name={`previousAddress1${index}`}
                label="Previous Address"
              >
                <Input
                  placeholder="Address 1"
                  onChange={(e) =>
                    handleChange(e.target.value, "addressOne", item.id)
                  }
                />
              </Form.Item>
              <Form.Item label=" " name={`previousAddress2${index}`}>
                <Input
                  placeholder="Address 2"
                  onChange={(e) =>
                    handleChange(e.target.value, "addressTwo", item.id)
                  }
                />
              </Form.Item>
              <Row>
                <Col span={10} style={{ marginLeft: "17%" }}>
                  <Form.Item label=" " name={`previousCity${index}`}>
                    <Input
                      placeholder="City"
                      onChange={(e) =>
                        handleChange(e.target.value, "city", item.id)
                      }
                    />
                  </Form.Item>
                </Col>
                <Col flex={1}></Col>
                <Col flex={5} span={5}>
                  <Form.Item label=" " name={`previousState${index}`}>
                    <Select
                      options={states}
                      onChange={(value) =>
                        handleChange(value, "state", item.id)
                      }
                    />
                  </Form.Item>
                </Col>
                <Col flex={1}></Col>
                <Col flex={2}>
                  <Form.Item label="" name={`previousZip${index}`}>
                    <Input
                      placeholder="Zip"
                      onChange={(e) =>
                        handleChange(e.target.value, "zipCode", item.id)
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item name={`previousCountry${index}`} label="Country">
                <Input
                  placeholder="Country"
                  onChange={(e) =>
                    handleChange(e.target.value, "country", item.id)
                  }
                />
              </Form.Item>
              <Form.Item
                name={`previousResidedFrom${index}`}
                label="Resided From"
                wrapperCol={{ span: 8 }}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  onChange={(value) =>
                    handleChange(value, "residedFrom", item.id)
                  }
                />
              </Form.Item>
              <Form.Item
                name={`previousResidedTo${index}`}
                label="Resided To"
                wrapperCol={{ span: 8 }}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  onChange={(value) =>
                    handleChange(value, "residedTo", item.id)
                  }
                />
              </Form.Item>
              <Form.Item
                label="Monthly Rent"
                name={`previousMonthlyRent${index}`}
                wrapperCol={{ span: 8 }}
              >
                <Input
                  prefix="$"
                  onChange={(e) =>
                    handleChange(e.target.value, "monthlyRent", item.id)
                  }
                />
              </Form.Item>
              <Form.Item
                label="Landlord Name"
                name={`previousLandLordName${index}`}
                wrapperCol={{ span: 8 }}
              >
                <Input
                  onChange={(e) =>
                    handleChange(e.target.value, "lanlordName", item.id)
                  }
                />
              </Form.Item>
              <Form.Item
                label="Landlord Phone Number"
                name={`previousLandLordNum${index}`}
                wrapperCol={{ span: 8 }}
              >
                <Input
                  onChange={(e) =>
                    handleChange(e.target.value, "lanlordPhoneNumber", item.id)
                  }
                />
              </Form.Item>
              <Form.Item
                label="Landlord Email Address"
                name={`previousLandLordEmail${index}`}
                wrapperCol={{ span: 8 }}
              >
                <Input
                  onChange={(e) =>
                    handleChange(
                      e.target.value,
                      "landlordEmailAddress",
                      item.id
                    )
                  }
                />
              </Form.Item>
              <Form.Item
                label="Reason For Leaving"
                name={`previousLandLordReason${index}`}
                wrapperCol={{ span: 8 }}
              >
                <TextArea
                  rows={4}
                  onChange={(e) =>
                    handleChange(e.target.value, "reasonForLeaving", item.id)
                  }
                />
              </Form.Item>
            </Card>
            <br />
          </li>
        ))}

        <Form.Item label="">
          <Button
            className="addPropertyGroupButton"
            type="primary"
            onClick={addPreviousAddress}
            size={"small"}
            icon={<i className="fa-solid fa-circle-plus"></i>}
          >
            Add Previous Address
          </Button>
        </Form.Item>
      </ul>
    </>
  );
}

export default Emails;
